export const locale = {
  'PROBLEM' : {
    'BREAKAGE' : 'Сломался',
    'INACTIVITY' : 'Нет связи',
    'DELAY' : 'Задержка этапа',
    'STOPPAGE' : 'Простаивает',
  },
}
